import { Component, Fragment, Prop, h } from '@stencil/core';
import { FinanceOption } from '../../types';

@Component({
  tag: 'kia-prislista-billan',
  shadow: true,
})
export class PrislistaBillan {
  @Prop() demo?: boolean = false;

  getExample() {
    return `<kia-prislista-billan></kia-prislista-billan>`;
  }

  render() {
    return (
      <Fragment>
        {this.demo && (
          <div style={{ margin: '3rem auto', maxWidth: '940px', padding: '0 1rem' }}>
            <h3>Lägg in följande snippet</h3>
            <div style={{ background: 'black', color: 'white', padding: '1rem' }}>
              <p>{this.getExample()}</p>
              <p>{` <script type="module" src="https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js"></script>`}</p>
            </div>
          </div>
        )}
        <kia-prislista type={FinanceOption.Loan} />;
      </Fragment>
    );
  }
}
